import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/compartimentLayout/importer/compartimentLayoutImporterActions';

export default importerReducers(actions);
